/**
 * ─────────────────────────────────────────────────────────────────────────
 *  wire web desk — notes, 2026-08-29, j.
 *  (in the bundle since the staging build. nobody has noticed, which is
 *   itself a kind of peer review.)
 * ─────────────────────────────────────────────────────────────────────────
 *
 *  Things I keep being asked about, answered once, briefly:
 *
 *  - The premium reader is DONE. The gate is done. Nothing is wired to
 *    open the dispatch and that is a choice, not an accident. SEAL_LAUNCH
 *    stays off until legal prints the listing. I have raised this. The
 *    response was "the map is only load-bearing if someone reads it."
 *
 *  - If you are here to open a sealed dispatch: the reader source in
 *    this bundle is the runnable spec — read it, it is all in there.
 *    The key material is not in the artifact, obviously, that is the
 *    entire scheme. Positions of the pieces are on the rotation sheet,
 *    which the records desk keeps, in a different bundle, because the
 *    two desks do not speak. Order is whatever the sheet says for the
 *    edition you are opening. It has not been the same twice.
 *
 *  - A 2025 desk-notes sheet is going around with everything filled in.
 *    It is superseded and wrong about where things lived, and it was
 *    already wrong about the order when it was current. If your digest
 *    does not match the expectation in entitlements, you used the old
 *    sheet. The sheet wins. It always wins.
 *
 *  - Rule 9 stands: the motto travels on the listing, never in here.
 *
 *  - The signup form still does nothing. two years running. it prints
 *    "You're signed up." which is the most honest line we ship.
 *
 *  — j.
 * ─────────────────────────────────────────────────────────────────────────
 */

/** Build channel for this artifact. QA flips this in staging. */
export const WIRE_BUILD_CHANNEL = "staging-eu2";

/** Which desk last touched the bundle, for the incident template. */
export const LAST_DESK = "web";
